import { mapActions, mapGetters } from 'vuex';
import { fetchUserAccount } from '../../api/base/customer';
import { serviceMap } from '@/config';

export default {
  props: {
    visible: { type: Boolean, default: false },
    customerId: Number,
    customerPhone: String,
    showMoney: {
      type: Boolean,
      default: false,
    },
    areaId: Number,
    isRefresh:{
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      serviceList: [],
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.fetchUserBaseInfo({
          customerId: this.customerId,
        });
        this.getAllData();
      }
    },
    isRefresh(newIsRefresh){
      if(newIsRefresh && this.visible){
        this.fetchUserBaseInfo({
          customerId: this.customerId,
        });
        this.getAllData();
      }
    },
    customerId(newId) {
      if (newId && this.visible) {
        this.fetchUserBaseInfo({
          customerId: this.customerId,
        });
        this.getAllData();
      }
    },
    customerPhone(newPhone) {
      if (!this.customerId && newPhone && this.visible) {
        this.fetchUserBaseInfoByPhone({
          customerPhone: this.customerPhone,
        });
        this.getAllData();
      }
    },
  },
  created() {
    if (this.visible && this.customerId) {
      this.fetchUserBaseInfo({
        customerId: this.customerId,
      });
      this.getAllData();
    }
    if (this.visible && !this.customerId && this.customerPhone) {
      this.fetchUserBaseInfoByPhone({
        customerPhone: this.customerPhone,
      });
      this.getAllData();
    }
  },
  computed: {
    ...mapGetters(['customerBaseInfo']),
  },
  methods: {
    ...mapActions(['fetchUserBaseInfo', 'fetchUserBaseInfoByPhone']),
    getAllData() {
      // console.log('in getAllData', this.customerId, this.customerPhone);

      if (this.showMoney) {
        const entity = this.customerId
          ? {
              areaId: this.areaId,
              customerId: this.customerId,
            }
          : {
              areaId: this.areaId,
              customerPhone: this.customerPhone,
            };
        fetchUserAccount(entity)
          .then(res => {
            this.serviceList = res.data;
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
    getServiceName(id) {
      let item = serviceMap.find(item => item.value === id);
      return item ? item.label : id;
    },
  },
};
